import React from 'react';
import { Row, TableBodyPropGetter, TableBodyProps } from 'react-table';
import { BringgFontIcons } from '@bringg/bringg-icons';
import TableRow from '../table-row/table-row';
import './table-body.scss';

interface ReactTableBodyProps<T extends object> {
	getTableBodyProps: (propGetter?: TableBodyPropGetter<T>) => TableBodyProps;
	rows?: Row<T>[];
	prepareRow: (row: Row<T>) => void;
	maxHeight?: number | string;
	expandIconName?: BringgFontIcons;
	customGroupRow?: (subRowsCount) => JSX.Element;
	children?: React.ReactNode;
	tableBodyClass?: string;
	tableRowClass?: string;
	tableCellClass?: string;
	tableCellTextClass?: string;
	page?: Array<Row<T>>;
}

const TableBody = <T extends object>(props: ReactTableBodyProps<T>) => {
	const {
		children,
		getTableBodyProps,
		rows,
		prepareRow,
		maxHeight,
		expandIconName,
		customGroupRow,
		tableBodyClass,
		tableRowClass,
		tableCellClass,
		tableCellTextClass,
		page
	} = props;

	const content = page ?? rows;

	return (
		<div {...getTableBodyProps()} className={`bringg-table-body ${tableBodyClass}`} style={{ maxHeight }}>
			{children
				? children
				: content.map(row => {
						prepareRow(row);
						return row.isGrouped && customGroupRow ? (
							customGroupRow(row)
						) : (
							<TableRow
								key={row.id}
								row={row}
								data-test-id={`table-row-${row.id}`}
								expandIconName={expandIconName}
								tableRowClass={tableRowClass}
								tableCellClass={tableCellClass}
								tableCellTextClass={tableCellTextClass}
							/>
						);
				  })}
		</div>
	);
};

export default TableBody;
